<template>
    <div>
        <el-input
            size="small" class="choose-search-input m-b-10"
            v-model="keyword" v-if="filterable"
            placeholder="请输入名称关键词或ID" @keyup.enter.native="handleSearch">
            <i slot="append" class="el-icon-search hand" @click="handleSearch"></i>
        </el-input>
        <el-table height="400" @row-click="handleChangeSelector" border :data="tableData" v-loading="tableLoading">
            <el-table-column v-if="tableData && tableData.length" width="40">
                <template slot-scope="scope">
                    <el-radio
                        :label="scope.row[rowKey]" :value="selectRow[rowKey]"
                        @change="handleChangeSelector(scope.row)">{{''}}</el-radio>
                </template>
            </el-table-column>

            <el-table-column v-for="col in tableHeader" :key="col.key" :prop="col.key" :label="col.title">
                <template slot-scope="scope" slot="header">
                    <slot name="table-header" :column="col" :scope="scope" :row="scope.row" :tableData="tableData" >
                        {{ col.title }}
                    </slot>
                </template>
                <template slot-scope="scope">
                    <slot name="table-body" :column="col" :scope="scope" :row="scope.row" :tableData="tableData" >
                        {{ scope.row[col.key] }}
                    </slot>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="pageable" style="text-align: right" class="m-t-10">
            <el-pagination
                :current-page.sync="page" :page-size.sync="pageSize" :total="total"
                @current-change="getData(0)" @size-change="getData(0)"
                v-bind="{
                    layout: 'total, prev, pager, next',
                    ...paginationProp,
                }"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
/**
 * 从对象中取出prop属性
 * prop可以为.分隔的字符串,例如 'tool.gdt.dict'
 */
const getAttrFromDict = (obj, prop) => {
    if (!obj) {
        return '';
    }
    const splitProp = prop.split('.');
    if (splitProp.length < 2) {
        return obj[prop];
    }
    return getAttrFromDict(obj[splitProp[0]], splitProp.slice(1).join('.'));
};

export default {
    name: 'DapSingleSelectPanel',
    props: {
        paramsMap: {
            type: Object,
            default: () => ({})
        },
        paginationProp: {
            type: Object,
            default: () => ({})
        },
        requestFn: {
            type: Function,
            default: () => Promise.resolve(),
        },
        defaultPageSize: {
            type: Number,
            default: 20
        },
        rowKey: {
            type: String,
            default: 'id',
        },
        selectRow: {
            type: Object,
            default: () => ({}),
        },
        filterable: {
            type: Boolean,
            default: true,
        },
        pageable: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            page: 0,
            pageSize: 20,
            tableData: [],
            tableHeader: [],
            keyword: '',
            total: 0,
            tableLoading: true,
        };
    },
    provide () {
        return {
            elForm: '',
            elFormItem: '',
        };
    },
    computed: {
        selfParamsMap () {
            return {
                page: this.paramsMap.page || 'page',
                pageSize: this.paramsMap.pageSize || 'pageSize',
                keyword: this.paramsMap.keyword || 'keyword',
                data: this.paramsMap.data || 'data',
                header: this.paramsMap.header || 'header',
                total: this.paramsMap.total || 'pagination.total',
            }
        },
    },

    methods: {
        getData (reset) {
            if (reset === 1) {
                this.page = 1;
                this.pageSize = this.defaultPageSize;
                this.keyword = '';
            }
            this.tableLoading = true;
            this.requestFn({
                [this.selfParamsMap.page]: this.page,
                [this.selfParamsMap.pageSize]: this.pageSize,
                [this.selfParamsMap.keyword]: this.keyword
            }).then(res => {
                this.tableLoading = false;
                if (!res) return;
                this.tableData = getAttrFromDict(res.data, this.selfParamsMap.data);
                this.tableHeader = getAttrFromDict(res.data, this.selfParamsMap.header);
                this.total = getAttrFromDict(res.data, this.selfParamsMap.total) || 0;
            });
        },
        handleSearch () {
            this.page = 1;
            this.pageSize = this.defaultPageSize;
            this.getData();
        },
        handleChangeSelector (row) {
            this.$emit('select', row);
        },
    },
};
</script>

<style lang="scss">

</style>
